import { render } from "./ViewsTab.vue?vue&type=template&id=3b0ff8d4"
import script from "./ViewsTab.vue?vue&type=script&lang=js"
export * from "./ViewsTab.vue?vue&type=script&lang=js"

import "./ViewsTab.vue?vue&type=style&index=0&id=3b0ff8d4&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3b0ff8d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b0ff8d4', script)) {
    api.reload('3b0ff8d4', script)
  }
  
  module.hot.accept("./ViewsTab.vue?vue&type=template&id=3b0ff8d4", () => {
    api.rerender('3b0ff8d4', render)
  })

}

script.__file = "src/components/no-message/tabs/ViewsTab.vue"

export default script